{
  "schemaVersion": "cogo.template.v1",
  "templateId": "bakery-storefront",
  "version": "1.0.0",
  "kind": "storefront",
  "source": {
    "projectRef": "apps/cogo-starter/public/apps/bakery-shop-new3",
    "structureHash": "sha256:0bc78a38885992900cd8160a2ec1029e8d5726d8d27741eb299a140f089817f9",
    "verificationEvidence": [
      "design-system-corpus:new3",
      "plan-a-contract-proof:cogo-web#1895"
    ]
  },
  "designBinding": {
    "file": "design-system.json",
    "rebinding": "allowed"
  },
  "slots": [
    {
      "slotId": "app-name",
      "type": "text",
      "address": {
        "kind": "app",
        "pointer": "/name"
      },
      "required": false,
      "sourceValue": "The Golden Crust Bakery",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "app-description",
      "type": "text",
      "address": {
        "kind": "app",
        "pointer": "/description"
      },
      "required": false,
      "sourceValue": "An artisanal bakery shop offering fresh sourdough, pastries, and custom cakes with online ordering and delivery tracking.",
      "constraint": {
        "maxLength": 242
      }
    },
    {
      "slotId": "ds-products-records",
      "type": "record-list",
      "address": {
        "kind": "record-list",
        "file": "data/products.json",
        "pointer": ""
      },
      "required": false,
      "sourceValue": [
        {
          "id": "b1",
          "name": "Artisan Sourdough",
          "price": 8.5,
          "image": "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?w=400&h=400&fit=crop",
          "category": "Bread",
          "description": "Naturally leavened, 24-hour fermented crusty sourdough.",
          "rating": 4.8
        },
        {
          "id": "b2",
          "name": "Butter Croissant",
          "price": 4.25,
          "image": "https://images.unsplash.com/photo-1555507036-ab1f4038808a?w=400&h=300&fit=crop",
          "category": "Pastry",
          "description": "Flaky, golden layers of pure French butter pastry.",
          "rating": 4.7
        },
        {
          "id": "b3",
          "name": "Blueberry Muffin",
          "price": 3.75,
          "image": "https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=400&h=300&fit=crop",
          "category": "Pastry",
          "description": "Bursting with fresh blueberries and topped with sugar crumble.",
          "rating": 4.6
        },
        {
          "id": "b4",
          "name": "French Baguette",
          "price": 3.25,
          "image": "https://images.unsplash.com/photo-1597079910443-60c43fc4f729?w=400&h=300&fit=crop",
          "category": "Bread",
          "description": "Traditional crispy exterior with a soft, airy interior.",
          "rating": 4.9
        },
        {
          "id": "b5",
          "name": "Cinnamon Roll",
          "price": 5,
          "image": "https://images.unsplash.com/photo-1509365465985-25d11c17e812?w=400&h=300&fit=crop",
          "category": "Pastry",
          "description": "Warm cinnamon spice with a thick cream cheese glaze.",
          "rating": 4.5
        },
        {
          "id": "b6",
          "name": "Seasonal Fruit Tart",
          "price": 6.5,
          "image": "https://images.unsplash.com/photo-1519915028121-7d3463d20b13?w=400&h=300&fit=crop",
          "category": "Cakes",
          "description": "Shortcrust pastry filled with vanilla custard and fresh fruit.",
          "rating": 4.7
        }
      ],
      "constraint": {
        "minCount": 1,
        "maxCount": 12,
        "recordSchema": {
          "id": null,
          "name": null,
          "price": null,
          "image": null,
          "category": null,
          "description": null,
          "rating": null
        }
      }
    },
    {
      "slotId": "cart-view-cart-title-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-title",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Your Cart",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-empty-title-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-empty-title",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Your cart is empty",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-empty-desc-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-empty-desc",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Looks like you haven't added any of our freshly baked goods yet.",
      "constraint": {
        "maxLength": 128
      }
    },
    {
      "slotId": "cart-view-cart-empty-shop-btn-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-empty-shop-btn",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Browse Bakery",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-item-image-alt",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-item-image",
        "field": "alt"
      },
      "required": false,
      "sourceValue": "Cart Item Image",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-item-qty-minus-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-item-qty-minus",
        "field": "text"
      },
      "required": true,
      "sourceValue": "-",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-item-qty-plus-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-item-qty-plus",
        "field": "text"
      },
      "required": true,
      "sourceValue": "+",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-item-remove-btn-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-item-remove-btn",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Remove",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-summary-title-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-summary-title",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Order Summary",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-summary-subtotal-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-summary-subtotal-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Subtotal",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-summary-shipping-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-summary-shipping-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Shipping",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-summary-shipping-value-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-summary-shipping-value",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Calculated at checkout",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-summary-total-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-summary-total-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Estimated Total",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-checkout-button-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-checkout-button",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Proceed to Checkout",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "cart-view-cart-secure-text-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "cart-view",
        "elementId": "cart-secure-text",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Secure Checkout",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-checkout-title-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "checkout-title",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Secure Checkout",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-checkout-subtitle-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "checkout-subtitle",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Complete your order for fresh artisanal baking.",
      "constraint": {
        "maxLength": 94
      }
    },
    {
      "slotId": "checkout-form-checkout-empty-text-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "checkout-empty-text",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Your cart is empty.",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-checkout-empty-subtext-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "checkout-empty-subtext",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Add some delicious pastries before checking out.",
      "constraint": {
        "maxLength": 96
      }
    },
    {
      "slotId": "checkout-form-contact-title-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "contact-title",
        "field": "text"
      },
      "required": true,
      "sourceValue": "1. Contact Information",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-email-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "email-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Email Address",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-email-input-placeholder",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "email-input",
        "field": "placeholder"
      },
      "required": false,
      "sourceValue": "you@example.com",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-phone-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "phone-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Phone Number",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-phone-input-placeholder",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "phone-input",
        "field": "placeholder"
      },
      "required": false,
      "sourceValue": "(555) 123-4567",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-delivery-title-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "delivery-title",
        "field": "text"
      },
      "required": true,
      "sourceValue": "2. Delivery Details",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-fname-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "fname-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "First Name",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-fname-input-placeholder",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "fname-input",
        "field": "placeholder"
      },
      "required": false,
      "sourceValue": "Jane",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-lname-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "lname-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Last Name",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-lname-input-placeholder",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "lname-input",
        "field": "placeholder"
      },
      "required": false,
      "sourceValue": "Doe",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-address-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "address-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Street Address",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-address-input-placeholder",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "address-input",
        "field": "placeholder"
      },
      "required": false,
      "sourceValue": "123 Baker Street",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-city-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "city-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "City",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-city-input-placeholder",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "city-input",
        "field": "placeholder"
      },
      "required": false,
      "sourceValue": "San Francisco",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-zip-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "zip-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "ZIP / Postal Code",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-zip-input-placeholder",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "zip-input",
        "field": "placeholder"
      },
      "required": false,
      "sourceValue": "94105",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-payment-title-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "payment-title",
        "field": "text"
      },
      "required": true,
      "sourceValue": "3. Payment Method",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-secure-text-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "secure-text",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Secure Encrypted",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-card-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "card-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Card Number",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-card-input-placeholder",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "card-input",
        "field": "placeholder"
      },
      "required": false,
      "sourceValue": "0000 0000 0000 0000",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-exp-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "exp-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Expiry Date",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-exp-input-placeholder",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "exp-input",
        "field": "placeholder"
      },
      "required": false,
      "sourceValue": "MM/YY",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-cvc-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "cvc-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "CVC",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-cvc-input-placeholder",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "cvc-input",
        "field": "placeholder"
      },
      "required": false,
      "sourceValue": "123",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-summary-title-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "summary-title",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Order Summary",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-summary-item-img-alt",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "summary-item-img",
        "field": "alt"
      },
      "required": false,
      "sourceValue": "Summary Item image",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-summary-items-list-empty-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "summary-items-list-empty",
        "field": "text"
      },
      "required": true,
      "sourceValue": "No items to display",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-summary-subtotal-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "summary-subtotal-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Subtotal",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-summary-delivery-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "summary-delivery-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Delivery Fee",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-summary-delivery-value-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "summary-delivery-value",
        "field": "text"
      },
      "required": true,
      "sourceValue": "$4.99",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-summary-total-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "summary-total-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Total",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-checkout-submit-btn-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "checkout-submit-btn",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Place Order",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "checkout-form-guarantee-text-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "checkout-form",
        "elementId": "guarantee-text",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Freshness guaranteed on all deliveries.",
      "constraint": {
        "maxLength": 78
      }
    },
    {
      "slotId": "hero-banner-hero-badge-text-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "hero-badge-text",
        "field": "text"
      },
      "required": true,
      "sourceValue": "The Golden Crust Bakery",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "hero-banner-hero-heading-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "hero-heading",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Baked with Love, Delivered Fresh",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "hero-banner-hero-description-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "hero-description",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Artisanal sourdough and pastries delivered fresh. Experience the warmth of our ovens right at your doorstep, crafted with organic ingredients and generations of passion.",
      "constraint": {
        "maxLength": 338
      }
    },
    {
      "slotId": "hero-banner-hero-btn-order-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "hero-btn-order",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Order Now",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "hero-banner-hero-btn-menu-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "hero-btn-menu",
        "field": "text"
      },
      "required": true,
      "sourceValue": "View Menu",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "hero-banner-trust-stat-1-val-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "trust-stat-1-val",
        "field": "text"
      },
      "required": true,
      "sourceValue": "10k+",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "hero-banner-trust-stat-1-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "trust-stat-1-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Happy Customers",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "hero-banner-trust-stat-2-num-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "trust-stat-2-num",
        "field": "text"
      },
      "required": true,
      "sourceValue": "4.9",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "hero-banner-trust-stat-2-label-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "trust-stat-2-label",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Average Rating",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "hero-banner-hero-image-src",
      "type": "image",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "hero-image",
        "field": "src"
      },
      "required": true,
      "sourceValue": "https://images.unsplash.com/photo-1509440159596-0249088772ff?q=80&w=2072&auto=format&fit=crop",
      "constraint": {
        "format": "url"
      }
    },
    {
      "slotId": "hero-banner-hero-image-alt",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "hero-image",
        "field": "alt"
      },
      "required": false,
      "sourceValue": "Freshly baked artisanal sourdough bread on a rustic table",
      "constraint": {
        "maxLength": 114
      }
    },
    {
      "slotId": "hero-banner-floating-title-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "floating-title",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Freshly Baked",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "hero-banner-floating-subtitle-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "hero-banner",
        "elementId": "floating-subtitle",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Every single morning",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "product-detail-back-text-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "product-detail",
        "elementId": "back-text",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Back to Shop",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "product-detail-add-to-cart-text-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "product-detail",
        "elementId": "add-to-cart-text",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Add to Cart",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "product-detail-perk-shipping-text-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "product-detail",
        "elementId": "perk-shipping-text",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Free Shipping",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "product-detail-perk-returns-text-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "product-detail",
        "elementId": "perk-returns-text",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Easy Returns",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "product-grid-product-grid-subtitle-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "product-grid",
        "elementId": "product-grid-subtitle",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Fresh from the oven",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "product-grid-product-grid-title-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "product-grid",
        "elementId": "product-grid-title",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Our Artisanal Bakes",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "product-grid-product-grid-desc-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "product-grid",
        "elementId": "product-grid-desc",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Handcrafted daily with organic flour, wild yeast, and a whole lot of love.",
      "constraint": {
        "maxLength": 148
      }
    },
    {
      "slotId": "product-grid-product-add-btn-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "product-grid",
        "elementId": "product-add-btn",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Add to Cart",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "product-grid-product-grid-container-empty-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "product-grid",
        "elementId": "product-grid-container-empty",
        "field": "text"
      },
      "required": true,
      "sourceValue": "No items to display",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-footer-logo-text-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "footer-logo-text",
        "field": "text"
      },
      "required": true,
      "sourceValue": "The Golden Crust Bakery",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-footer-tagline-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "footer-tagline",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Artisanal sourdough and pastries delivered fresh.",
      "constraint": {
        "maxLength": 98
      }
    },
    {
      "slotId": "store-footer-footer-address-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "footer-address",
        "field": "text"
      },
      "required": true,
      "sourceValue": "123 Baker Street, Crustville",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-footer-phone-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "footer-phone",
        "field": "text"
      },
      "required": true,
      "sourceValue": "(555) 867-5309",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-footer-shop-heading-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "footer-shop-heading",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Shop",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-link-sourdough-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "link-sourdough",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Fresh Sourdough",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-link-pastries-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "link-pastries",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Sweet Pastries",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-link-cakes-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "link-cakes",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Custom Cakes",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-link-cart-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "link-cart",
        "field": "text"
      },
      "required": true,
      "sourceValue": "View Cart",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-footer-about-heading-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "footer-about-heading",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Our Bakery",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-link-story-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "link-story",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Our Story",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-link-faq-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "link-faq",
        "field": "text"
      },
      "required": true,
      "sourceValue": "FAQ & Shipping",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-link-contact-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "link-contact",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Contact Us",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-link-track-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "link-track",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Track Order",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-footer-newsletter-heading-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "footer-newsletter-heading",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Stay Fresh",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-footer-newsletter-desc-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "footer-newsletter-desc",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Subscribe to our newsletter for weekly specials and fresh-out-of-the-oven updates.",
      "constraint": {
        "maxLength": 164
      }
    },
    {
      "slotId": "store-footer-footer-newsletter-input-placeholder",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "footer-newsletter-input",
        "field": "placeholder"
      },
      "required": false,
      "sourceValue": "Email address",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-footer-newsletter-submit-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "footer-newsletter-submit",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Subscribe",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-footer-copyright-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "footer-copyright",
        "field": "text"
      },
      "required": true,
      "sourceValue": "© 2024 The Golden Crust Bakery. All rights reserved.",
      "constraint": {
        "maxLength": 104
      }
    },
    {
      "slotId": "store-footer-link-privacy-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "link-privacy",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Privacy Policy",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-footer-link-terms-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-footer",
        "elementId": "link-terms",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Terms of Service",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-nav-brand-text-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-nav",
        "elementId": "brand-text",
        "field": "text"
      },
      "required": true,
      "sourceValue": "The Golden Crust Bakery",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-nav-search-input-placeholder",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-nav",
        "elementId": "search-input",
        "field": "placeholder"
      },
      "required": false,
      "sourceValue": "Search fresh pastries...",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-nav-link-menu-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-nav",
        "elementId": "link-menu",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Menu",
      "constraint": {
        "maxLength": 64
      }
    },
    {
      "slotId": "store-nav-link-about-text",
      "type": "text",
      "address": {
        "kind": "element",
        "blockId": "store-nav",
        "elementId": "link-about",
        "field": "text"
      },
      "required": true,
      "sourceValue": "Our Story",
      "constraint": {
        "maxLength": 64
      }
    }
  ],
  "terminologySurface": {
    "terms": [
      "빵집",
      "베이커리",
      "bakery",
      "제과점",
      "스토어프론트",
      "storefront"
    ],
    "scope": "platform"
  }
}
